import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	OnDestroy,
	Output,
} from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	FormControl,
	Validators,
} from '@angular/forms';
import { Subscription as RxJsSubscription } from 'rxjs';
import { ErrorService, ExplainErrorsService } from '@app/services';
import { ActivityLog } from '../activity-log';
import { ActivityLogService } from '../activity-log.service';
@Component({
	selector: 'hpf-activity-log-form',
	templateUrl: './activity-log-form.component.html',
})
export class ActivityLogFormComponent implements OnInit, OnDestroy {
	/** The model subscription */
	private modelSubscription: RxJsSubscription;
	/** The activity log to inject in the form */
	@Input() activityLog: ActivityLog;
	/** Called the save button is clicked for a new instance */
	@Output() create = new EventEmitter<ActivityLog>();
	/** Called the save button is clicked for an existing instance */
	@Output() update = new EventEmitter<void>();
	/** Called the delete button is clicked */
	@Output() delete = new EventEmitter<void>();
	/** Set loading state of the form */
	@Input() loading = false;
	/** Enable the deletion button */
	@Input() deletable = true;
	/** Denotes if deltion in progress */
	deleting = false;
	/** Show delete modal */
	deleteModal = false;
	/** The form group to use */
	form: FormGroup;
	/** Denotes if the form is pending */
	saving = false;
	/** Constructor */
	constructor(
		private formBuilder: FormBuilder,
		private errorService: ErrorService,
		public explainErrorsService: ExplainErrorsService,
		private activityLogService: ActivityLogService
	) {}
	/** Init */
	ngOnInit() {
		// Create form
		this.form = this.formBuilder.group({});
		// Update form when model loads or changes
		this.modelSubscription = this.activityLog.subscribe(() => {
			this.updateForm();
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.modelSubscription.unsubscribe();
	}
	/** Called on form submit */
	async onSubmit(): Promise<void> {
		// Saving flag
		this.saving = true;
		try {
			// Update model
			this.updateModel();
			// Creation or update ?
			if (this.activityLog.isNew()) {
				// Creation
				const activityLog: ActivityLog = await this.activityLogService.create(
					this.activityLog.toPayload()
				);
				this.create.next(activityLog);
			} else {
				// Update
				await this.activityLogService.update(
					this.activityLog.getId(),
					this.activityLog.toPayload()
				);
				this.update.next();
			}
		} catch (error) {
			this.errorService.handle(error);
		}
		// Saving flag
		this.saving = false;
	}
	/** Update models properties from inputs values */
	private updateModel(): void {
		for (const key of Object.keys(this.form.controls)) {
			this.activityLog.props[key] = this.form.get(key).value;
		}
	}
	/** Update inputs values from models properties */
	private updateForm(): void {
		this.form.setValue({});
	}
	/** Called on deletion */
	onDelete(): void {
		this.deleting = true;
		this.activityLogService
			.remove(this.activityLog.getId())
			.then(() => {
				this.delete.next();
			})
			.catch((error) => this.errorService.handle(error))
			.then(() => (this.deleting = false));
	}
}
